import { render, staticRenderFns } from "./supervise_home.vue?vue&type=template&id=1d8839a7&scoped=true"
import script from "./supervise_home.vue?vue&type=script&lang=js"
export * from "./supervise_home.vue?vue&type=script&lang=js"
import style0 from "./supervise_home.vue?vue&type=style&index=0&id=1d8839a7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8839a7",
  null
  
)

export default component.exports